var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118.02 144.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#71777e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.95,15.17c-.91-1.04-1.62-2.22-2.11-3.53-.5-1.31-.75-2.66-.75-4.07s.25-2.74.75-4.05c.5-1.31,1.2-2.48,2.11-3.53h1.01c-.43.68-.82,1.44-1.17,2.28-.35.83-.62,1.7-.83,2.6-.2.9-.31,1.8-.31,2.7s.1,1.79.31,2.7c.2.91.48,1.79.82,2.62.34.83.73,1.59,1.18,2.28h-1.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.04,37.03l-8.68-15.43h1.49l8.69,15.43h-1.51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.96,43.2c.92,1.04,1.63,2.22,2.12,3.53.49,1.31.74,2.66.74,4.07s-.25,2.73-.74,4.04c-.49,1.31-1.2,2.49-2.12,3.54h-.99c.43-.7.82-1.46,1.16-2.29.34-.83.61-1.7.82-2.6.2-.91.31-1.8.31-2.69s-.1-1.8-.3-2.71c-.2-.91-.47-1.78-.82-2.61-.35-.83-.74-1.59-1.17-2.28h.99Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.26,77.15l.72-3.26H0v-1.33h2.29l.63-2.81H.72v-1.35h2.48l.85-3.78h1.42l-.86,3.78h2.65l.85-3.78h1.42l-.88,3.78h1.89v1.35h-2.16l-.63,2.81h2.14v1.33h-2.45l-.72,3.26h-1.39l.7-3.26h-2.66l-.7,3.26h-1.4Zm2.41-4.59h2.66l.65-2.81h-2.68l-.63,2.81Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.06,77.15l.72-3.26h-1.98v-1.33h2.29l.63-2.81h-2.2v-1.35h2.48l.85-3.78h1.42l-.86,3.78h2.65l.85-3.78h1.42l-.88,3.78h1.89v1.35h-2.16l-.63,2.81h2.14v1.33h-2.45l-.72,3.26h-1.39l.7-3.26h-2.66l-.7,3.26h-1.4Zm2.41-4.59h2.66l.65-2.81h-2.68l-.63,2.81Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.59,73.12v-1.67h4.55v1.67h-4.55Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.39,73.12v-1.67h4.55v1.67h-4.55Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.19,73.12v-1.67h4.55v1.67h-4.55Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.99,73.12v-1.67h4.55v1.67h-4.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.79,73.12v-1.67h4.55v1.67h-4.55Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.59,73.12v-1.67h4.55v1.67h-4.55Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.39,73.12v-1.67h4.55v1.67h-4.55Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m100.19,73.12v-1.67h4.55v1.67h-4.55Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.84,77.06v-1.57l7.65-2.92-7.65-2.92v-1.58l9.18,3.55v1.89l-9.18,3.55Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.96,86.4c.92,1.04,1.63,2.22,2.12,3.53.49,1.31.74,2.66.74,4.07s-.25,2.73-.74,4.04c-.49,1.31-1.2,2.49-2.12,3.54h-.99c.43-.7.82-1.46,1.16-2.29.34-.83.61-1.7.82-2.6.2-.91.31-1.8.31-2.69s-.1-1.8-.3-2.71c-.2-.91-.47-1.78-.82-2.61-.35-.83-.74-1.59-1.17-2.28h.99Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43.36,123.43l8.69-15.43h1.49l-8.68,15.43h-1.51Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.95,144.77c-.91-1.04-1.62-2.22-2.11-3.53-.5-1.31-.75-2.66-.75-4.07s.25-2.74.75-4.05c.5-1.31,1.2-2.48,2.11-3.53h1.01c-.43.68-.82,1.44-1.17,2.28-.35.83-.62,1.7-.83,2.6-.2.9-.31,1.8-.31,2.7s.1,1.79.31,2.7c.2.91.48,1.79.82,2.62.34.83.73,1.59,1.18,2.28h-1.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.20c92fef04896a78a3066342f6924f5a.svg";
export { ForwardRef as ReactComponent };